export default "__VITE_ASSET__F$gvyksO__"